import type { JSX } from 'react';

/**
 * AppRetiredGate — full-screen notice shown when the web app is retired in
 * favor of the native Android app. Intentionally has ZERO dependencies on
 * wallet/auth/DB state so it always renders, even if data or auth is broken.
 */
export default function AppRetiredGate(): JSX.Element {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          maxWidth: 340,
          width: '100%',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
          background: '#12122a',
          borderRadius: 16,
          padding: '28px 24px',
        }}
      >
        <h1
          style={{
            fontFamily: "'Syne', sans-serif",
            fontWeight: 700,
            fontSize: 24,
            lineHeight: 1.3,
            color: '#ffffff',
            margin: 0,
          }}
        >
          We&apos;ve moved to a native app
        </h1>

        <p
          style={{
            fontFamily: "'DM Mono', monospace",
            fontWeight: 400,
            fontSize: 14,
            lineHeight: 1.6,
            color: 'rgba(255,255,255,0.6)',
            margin: 0,
          }}
        >
          SeekScape is now a native Android app built with Kotlin and Jetpack
          Compose. Download the new version from the Solana dApp Store to
          keep using it.
        </p>
      </div>
    </div>
  );
}
